import { render } from "./Filas.vue?vue&type=template&id=7720b2d6&scoped=true"
import script from "./Filas.vue?vue&type=script&lang=js"
export * from "./Filas.vue?vue&type=script&lang=js"

import "./Filas.vue?vue&type=style&index=0&id=7720b2d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7720b2d6"]])

export default __exports__